<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add User KYC Detail
        </v-card-title>
        <v-card-text>
          <template v-if="form && form.documents && form.documents.length != 0">
            <!-- <h3 class="my-4">List of Outlet(s) for this Pjp Reference:</h3> -->
            <v-row
              v-for="(document, document_index) in form.documents"
              :key="`document${document_index}`"
            >
              <v-col sm="3">
                <v-autocomplete
                  ref="user"
                  outlined
                  v-model="document.user_id"
                  :items="userItems"
                  label="User *"
                  prepend-inner-icon="mdi-account-tie-outline"
                  clearable
                  :error-messages="
                    getFieldError(`documents.${document_index}.user_id`)
                  "
                ></v-autocomplete>
              </v-col>
              <v-col sm="3">
                <v-autocomplete
                  ref="documents"
                  outlined
                  v-model="document.doc_name_id"
                  :items="documentItems"
                  label="Document Type *"
                  prepend-inner-icon="mdi-account-tie-outline"
                  clearable
                  :error-messages="
                    getFieldError(`documents.${document_index}.doc_name_id`)
                  "
                ></v-autocomplete>
              </v-col>
              <v-col sm="3">
                <v-text-field
                  v-model="document.doc_no"
                  outlined
                  label="Document No"
                  prepend-inner-icon="mdi-card-text-outline"
                  :error-messages="
                    getFieldError(`documents.${document_index}.doc_no`)
                  "
                ></v-text-field>
              </v-col>
              <v-col sm="2">
                <v-file-input
                  v-model="document.doc_path"
                  label="Upload Document"
                  accept="image/*"
                  show-size
                  dense
                  :error-messages="
                    getFieldError(`documents.${document_index}.doc_path`)
                  "
                  :ref="`fileInput`"
                  @change="onFileChange"
                ></v-file-input>

                <div v-if="previewImage" class="mt-5">
                  <label>Image Preview</label>
                  <br />
                  <img
                    :src="previewImage"
                    style="height: 30%; width: 30%; object-fit: contain"
                  />
                </div>
              </v-col>
              <v-col sm="3">
                <v-autocomplete
                  ref="user"
                  outlined
                  v-model="document.status"
                  :items="statusItems"
                  label="Status *"
                  prepend-inner-icon="mdi-account-tie-outline"
                  clearable
                  :error-messages="errors.status"
                ></v-autocomplete>
              </v-col>
              <v-col sm="1">
                <v-dialog
                  v-model="isDeleteDocumentDialogs[document_index]"
                  max-width="600px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      fab
                      class="ml-9"
                      small
                      dark
                      color="red"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark> mdi-close-thick </v-icon>
                    </v-btn>
                  </template>
                  <v-card elevation="10">
                    <v-card-title>
                      <v-icon large color="primary">
                        mdi-information-outline
                      </v-icon>
                      &nbsp; Do you want to remove the variant?
                    </v-card-title>
                    <v-card-text>
                      <v-btn
                        color="primary"
                        @click.stop="deleteDocument(document)"
                      >
                        Yes
                      </v-btn>
                      &nbsp;
                      <v-btn
                        color="red"
                        dark
                        @click.stop="isDeleteDocumentDialogs = []"
                      >
                        No
                      </v-btn>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </template>
          <v-row>
            <v-col sm="12" class="mb-5">
              <v-btn small rounded color="primary" @click="Add_Document">
                Add Document
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save User KYC Detail
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "UsersKYCDetailCreatePage",
  data() {
    return {
      form: {
        documents: [
          {
            user_id: "",
            doc_name_id: "",
            doc_no: "",
            doc_path: null,
            status: "0",
          },
        ],
      },
      previewImage: null,
      isDeleteDocumentDialogs: [],
      documentItems: [],
      userItems: [],
      statusItems: [
        { id: 1, text: "APPROVED", value: "1" },
        { id: 2, text: "PENDING", value: "0" },
      ],

      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`masters?context=kyc_detail`)
        .then((masters) => {
          masters = masters.data;
          //documents
          masters.documents.forEach((document) => {
            this.documentItems.push({
              id: document.id,
              text: document.description,
              value: document.id,
            });
          });
          //user
          masters.users.forEach((user) => {
            this.userItems.push({
              id: user.id,
              text: user.first_name + " " + user.last_name,
              value: user.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
    async save() {
      let formData = new FormData();
      console.log("document", this);

      this.form.documents.forEach((doc, index) => {
        formData.append(`documents[${index}][user_id]`, doc.user_id);
        formData.append(`documents[${index}][doc_name_id]`, doc.doc_name_id);
        formData.append(`documents[${index}][doc_no]`, doc.doc_no);
        // append file only if exists
        if (doc.doc_path) {
          formData.append(`documents[${index}][doc_path]`, doc.doc_path);
        }
      });
      try {
        this.isLoading = true;
        await axios.post("/user_kyc_details", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        this.isLoading = false;
        this.$router.back();
      } catch (error) {
        this.errors = error.response.data.errors;
        console.error("error", this.errors);
        this.isLoading = false;
      }
    },

    onFileChange(file) {
      if (file && file instanceof File) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.previewImage = null;
      }
    },

    resetFile() {
      this.document.doc_path = null;
      this.previewImage = null;

      // If you're using a ref for reset
      if (this.$refs.fileInput) {
        this.$refs.fileInput.reset();
      }
    },
    getFieldError(fieldPath) {
      console.log("fieldPath", fieldPath);

      console.log("this.errors[fieldPath]", this.errors[fieldPath]);
      return this.errors[fieldPath] || [];
    },
    Add_Document() {
      let document = {
        user_id: "",
        doc_name_id: "",
        doc_no: "",
        doc_path: null,
        status: "0",
      };
      console.log("product_document", document);
      this.form.documents.push(document);
    },
    deleteDocument(document) {
      this.form.documents.splice(this.form.documents.indexOf(document), 1);
      this.isDeleteDocumentDialogs = [];
    },
  },
};
</script>
